import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import Popup2 from "./Popup2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Import the Popup1 component to reuse its content
import Popup1 from "./Popup1";

function UserPreferences() {
  const navigate = useNavigate();
  const { emailId, isLoggedIn } = useContext(UserContext);
  const [showPopup2, setShowPopup2] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(false);

  // Check if user is logged in
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);

  // Check if it's the user's first time
  useEffect(() => {
    const checkIfFirstTime = async () => {
      try {
        const response = await axios.get(
          "/api/check-firsttime",
          {
            params: { email_id: emailId },
          }
        );
        setIsFirstTime(response.data.firsttime === 1);
      } catch (error) {
        console.error("Error checking first time:", error);
      }
    };
    
    if (emailId) {
      checkIfFirstTime();
    }
  }, [emailId]);

  const handleClose = () => {
    navigate("/");
  };

  return (
    <div className="user-preferences-page" style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>Your Preferences</h1>
      
      {/* Wrap Popup1 in our own DndProvider to control the context */}
      <DndProvider backend={HTML5Backend}>
        <Popup1 onClose={handleClose} noDndProvider={true} />
      </DndProvider>
    </div>
  );
}

export default UserPreferences; 